<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-1">รายการเรียกเก็บ</h5>
          <div class="text-muted small">
            รายละเอียดค่าส่วนกลางและค่าปรับในใบแจ้งหนี้นี้
          </div>
        </div>
        <span
          class="badge text-bg-light border text-dark rounded-pill px-3 py-2"
        >
          {{ items.length }} รายการ
        </span>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>รายการ</th>
              <th class="text-end">จำนวน</th>
              <th class="text-end">ราคา/หน่วย</th>
              <th class="text-end">รวม</th>
            </tr>
          </thead>
          <tbody v-if="items.length">
            <tr v-for="item in items" :key="item.id">
              <td class="fw-semibold">{{ item.description }}</td>
              <td class="text-end">{{ item.qty }}</td>
              <td class="text-end">{{ formatCurrency(item.unitPrice) }}</td>
              <td class="text-end fw-semibold">
                {{ formatCurrency(item.amount) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" class="text-center py-5 text-muted">
                <i class="bi bi-list-ul fs-2 d-block mb-2"></i>
                ยังไม่มีรายการเรียกเก็บ
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
